module.exports = __webpack_public_path__ + "img/button-start-play.69fef9f3.svg";